import React from 'react'
import { useNavigate } from 'react-router-dom'
import { logout } from "redux/LoginSlice";
import CustomButton from 'ui/CustomButton/CustomButton'
import styles from "styles/component/NoItemFound.module.scss";
import asset from "json/assets";
import { useDispatch } from 'react-redux';


export default function PageAccessDenied() {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    
    
    const redirectToHome =()=>{
      
      dispatch(logout());
      navigate("/");
    }
  return (
    <div className={styles.not_found_container}>
    <div className={styles.not_access_cont}>
      <figure>
          <img src={asset.PageCanNotAccess} alt="" />
          <h5 style={{color: "#1967e5",fontWeight: "600", paddingBottom: "35px"}}>Sorry, you cannot view the page.</h5>
      </figure>
      <CustomButton type='button' onClick={redirectToHome}>Back To Home</CustomButton>
    </div>
  </div>
  )
}
